// Mr. Fermore product page (mf-pdp template): gallery, quantity, bundle, quick add,
// sticky add-to-cart bar, product recommendations and recently viewed.
// The main add to cart is handled by the theme's <product-form> (assets/product-form.js).

(function () {
  // Loaded by several sections; run once
  if (window.mfProduct) return;
  window.mfProduct = true;

  const RECENT_KEY = 'mf-recently-viewed';
  const RECENT_MAX = 12;

  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // Adds items with one request and opens the theme's cart drawer (falls back to the cart page)
  async function addToCart(items) {
    const cartDrawer = document.querySelector('cart-drawer');
    const body = { items };
    if (cartDrawer) {
      body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message);

    if (!cartDrawer) {
      window.location = window.routes.cart_url;
      return;
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mf-product', cartData: data });
    }
    cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents(data);
  }

  function initGallery(root) {
    const mainImg = root.querySelector('[data-mf-main-img]');
    const thumbs = root.querySelectorAll('[data-mf-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        mainImg.srcset = thumb.dataset.srcset;
        mainImg.src = thumb.dataset.src;
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  }

  function initQuantity(root) {
    const input = root.querySelector('.mf-qty__input');
    if (!input) return;
    const min = Number(input.min) || 1;
    const max = Number(input.max) || 99;

    root.querySelectorAll('[data-mf-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = (Number(input.value) || min) + Number(btn.dataset.mfQty);
        input.value = Math.min(Math.max(next, min), max);
      });
    });
  }

  // Short name like the Liquid snippet mf-short-title: "Pulpa de Mango · 32 oz" for pulp-line handles
  function shortTitle(product, prefix, namesRaw) {
    const handle = (product.handle || '').replace(/^test-/, '');
    if (prefix && handle.startsWith(prefix)) {
      const parts = handle.slice(prefix.length).split('-x-');
      if (parts.length > 1) {
        const names = {};
        (namesRaw || '').split('|').forEach((line) => {
          const i = line.indexOf(':');
          if (i > 0) names[line.slice(0, i).trim()] = line.slice(i + 1).trim();
        });
        const slug = parts[0];
        const name = names[slug] || slug.replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase());
        return `Pulpa de ${name} · ${parts[parts.length - 1].replace(/-oz$/, '')} oz`;
      }
    }
    return (product.title || '').replace('[TEST] ', '');
  }

  function sizedImage(url, width) {
    if (!url) return '';
    const full = url.startsWith('//') ? `https:${url}` : url;
    return `${full}${full.includes('?') ? '&' : '?'}width=${width}`;
  }

  // Replaces the theme-editor add-ons with the product's own complementary products (Shopify
  // Search & Discovery), when it has any. Otherwise the theme-editor add-ons stay.
  async function loadComplementary(bundle) {
    const url = bundle.dataset.complementaryUrl;
    if (!url) return;
    try {
      const data = await (await fetch(url)).json();
      const format = bundle.dataset.moneyFormat;
      const currentId = Number(bundle.dataset.productId);
      const rows = (data.products || [])
        .filter((p) => p.id !== currentId)
        .map((p) => ({ p, v: (p.variants || []).find((v) => v.available) }))
        .filter(({ v }) => v)
        .map(({ p, v }, i) => {
          const name = escapeHtml(shortTitle(p, bundle.dataset.linePrefix, bundle.dataset.flavorNames));
          const img = p.featured_image
            ? `<img class="mf-bundle__thumb" src="${escapeHtml(sizedImage(p.featured_image, 120))}" alt="" loading="lazy" width="44" height="44">`
            : '';
          const checked = i === 0 && bundle.dataset.precheck === 'true' ? ' checked' : '';
          return `<label class="mf-bundle__item">
            <input type="checkbox" class="mf-bundle__check" data-mf-bundle-addon data-variant-id="${v.id}" data-price="${v.price}"${checked}>
            ${img}
            <a class="mf-bundle__name" href="${escapeHtml(p.url || `/products/${p.handle}`)}">${name}</a>
            <span class="mf-bundle__price">${escapeHtml(formatMoney(v.price, format))}</span>
          </label>`;
        });
      if (!rows.length) return;
      const group = bundle.querySelector('[data-mf-bundle-addons]');
      group.querySelectorAll('.mf-bundle__item').forEach((el) => el.remove());
      group.insertAdjacentHTML('beforeend', rows.join(''));
      bundle.dataset.source = 'complementary';
    } catch (e) {
      // Keep the theme-editor add-ons
    }
  }

  // "Frequently bought together": main product (locked) + optional add-ons
  async function initBundle(root) {
    const bundle = root.querySelector('[data-mf-bundle]');
    if (!bundle) return;

    await loadComplementary(bundle);
    if (!bundle.querySelector('[data-mf-bundle-addon]')) return; // nothing to offer: stays hidden
    bundle.hidden = false;

    const main = bundle.querySelector('[data-mf-bundle-main]');
    const addons = bundle.querySelectorAll('[data-mf-bundle-addon]');
    const totalEl = bundle.querySelector('[data-mf-bundle-total]');
    const mainPriceEl = bundle.querySelector('[data-mf-bundle-main-price]');
    const qtyEl = bundle.querySelector('[data-mf-bundle-qty]');
    const button = bundle.querySelector('[data-mf-bundle-add]');
    const errorEl = bundle.querySelector('[data-mf-bundle-error]');
    const qtyInput = root.querySelector('.mf-qty__input');
    const format = bundle.dataset.moneyFormat;

    const mainQty = () => Math.max(Number(qtyInput && qtyInput.value) || 1, 1);

    function update() {
      const qty = mainQty();
      const mainTotal = Number(main.dataset.price) * qty;
      let total = mainTotal;
      addons.forEach((a) => {
        if (a.checked) total += Number(a.dataset.price);
      });
      mainPriceEl.textContent = formatMoney(mainTotal, format);
      qtyEl.hidden = qty < 2;
      qtyEl.textContent = `× ${qty}`;
      totalEl.textContent = formatMoney(total, format);
    }

    addons.forEach((a) => a.addEventListener('change', update));
    if (qtyInput) {
      qtyInput.addEventListener('input', update);
      root.querySelectorAll('[data-mf-qty]').forEach((b) => b.addEventListener('click', update));
    }
    update();

    button.addEventListener('click', async () => {
      const items = [{ id: Number(main.dataset.variantId), quantity: mainQty() }];
      addons.forEach((a) => {
        if (a.checked) items.push({ id: Number(a.dataset.variantId), quantity: 1 });
      });

      button.disabled = true;
      errorEl.hidden = true;
      try {
        await addToCart(items);
      } catch (error) {
        errorEl.textContent = error.message || 'No se pudo agregar el combo. Intenta de nuevo.';
        errorEl.hidden = false;
      } finally {
        button.disabled = false;
      }
    });
  }

  // Sticky bar: visible once the main add-to-cart row has scrolled above the viewport
  function initSticky(root) {
    const sticky = root.querySelector('[data-mf-sticky]');
    const cta = root.querySelector('[data-mf-cta]');
    if (!sticky || !cta) return;

    // Checked on every scroll (not only when the button crosses the edge), so jumps like
    // anchor links or fast swipes can't skip it
    let ticking = false;
    const update = () => {
      ticking = false;
      const hide = cta.getBoundingClientRect().bottom > 0;
      sticky.hidden = hide;
      // Theme previews only: Shopify's preview bar (#PBarNextFrameWrapper, fixed at the bottom) would
      // cover the sticky bar, so lift the bar above it. Shoppers never have a preview bar.
      const pbar = document.getElementById('PBarNextFrameWrapper');
      const pbarRect = pbar ? pbar.getBoundingClientRect() : null;
      const pbarHeight =
        pbarRect && pbarRect.height > 0 && pbarRect.height < window.innerHeight / 3 && Math.round(pbarRect.bottom) >= window.innerHeight - 1
          ? Math.round(pbarRect.height)
          : 0;
      sticky.style.bottom = pbarHeight ? `${pbarHeight}px` : '';
      // Space reserved for the bar; chat and popup layers end above it (see mf-product.css)
      document.documentElement.style.setProperty(
        '--mf-sticky-offset',
        hide ? '0px' : `${sticky.offsetHeight + pbarHeight}px`
      );
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
    keepPopupsAboveSticky();

    const form = root.querySelector('product-form form');
    sticky.querySelector('[data-mf-sticky-add]').addEventListener('click', () => {
      if (form && form.requestSubmit) form.requestSubmit();
      else if (form) form.querySelector('[type="submit"]').click();
    });
  }

  // The Shopify Forms popup (10% discount) renders inside a shadow root that page CSS can't reach.
  // Add one rule inside it so its full-screen layers end above the sticky bar and hide while the cart drawer is open (--mf-sticky-offset
  // inherits into the shadow root). The popup itself and its timing stay as configured in the app.
  function keepPopupsAboveSticky() {
    // Also hidden while the cart drawer is open (--mf-overlay-visibility, set in mf-product.css)
    const css = '#app-embed, [class~="fixed"][class~="inset-0"], section[class*="_overlay_"] {' +
      ' bottom: var(--mf-sticky-offset, 0px) !important; height: auto !important;' +
      ' transition: bottom 0.25s ease; visibility: var(--mf-overlay-visibility, visible) !important; }';
    let tries = 0;
    const inject = () => {
      document.querySelectorAll('shopify-forms-embed').forEach((host) => {
        const root = host.shadowRoot;
        if (!root || root.querySelector('style[data-mf-sticky]')) return;
        const style = document.createElement('style');
        style.dataset.mfSticky = '';
        style.textContent = css;
        root.appendChild(style);
      });
      // The app loads after the page; keep checking for a while
      if (++tries < 30) setTimeout(inject, 1000);
    };
    inject();
  }

  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  // Remembers this product in the shopper's own browser (nothing is sent anywhere)
  function saveRecent(root) {
    const d = root.dataset;
    if (!d.recentHandle) return;
    const entry = {
      handle: d.recentHandle,
      title: d.recentTitle,
      url: d.recentUrl,
      image: d.recentImage,
      price: d.recentPrice,
      variant: d.recentVariant,
      available: d.recentAvailable === 'true',
    };
    const list = [entry, ...readRecent().filter((p) => p.handle !== entry.handle)].slice(0, RECENT_MAX);
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (e) {
      // Storage full or blocked: recently viewed simply stays empty
    }
  }

  function recentCard(p) {
    const title = escapeHtml(p.title);
    const image = p.image
      ? `<img class="mf-card__img" src="${escapeHtml(p.image)}" alt="" loading="lazy" width="400" height="400">`
      : '';
    const action = p.available
      ? `<button type="button" class="mf-card__add" data-mf-quick-add="${escapeHtml(p.variant)}" aria-label="Agregar ${title} al carrito" title="Agregar al carrito">+</button>`
      : '<span class="mf-card__soldout">Agotado</span>';
    return `<div class="mf-card">
      <a class="mf-card__media" href="${escapeHtml(p.url)}" tabindex="-1" aria-hidden="true">${image}</a>
      <div class="mf-card__body">
        <a class="mf-card__title" href="${escapeHtml(p.url)}">${title}</a>
        <div class="mf-card__footer"><span class="mf-card__price">${escapeHtml(p.price)}</span>${action}</div>
      </div>
    </div>`;
  }

  function initRecentRow(row) {
    const current = row.dataset.currentHandle;
    const limit = Number(row.dataset.limit) || 8;
    const items = readRecent()
      .filter((p) => p.handle !== current)
      .slice(0, limit);
    if (!items.length) return;
    row.querySelector('[data-mf-row-track]').innerHTML = items.map(recentCard).join('');
    row.hidden = false;
  }

  async function initRecommendationsRow(row) {
    if (!row.dataset.url) return;
    try {
      const response = await fetch(row.dataset.url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const track = doc.querySelector('[data-mf-row-track]');
      if (!track || !track.children.length) return;
      row.querySelector('[data-mf-row-track]').innerHTML = track.innerHTML;
      row.hidden = false;
    } catch (e) {
      // Recommendations are optional; keep the row hidden
    }
  }

  function init(scope = document) {
    scope.querySelectorAll('.mf-pdp').forEach((root) => {
      if (root.dataset.mfInit) return;
      root.dataset.mfInit = 'true';

      const rowType = root.dataset.mfRow;
      if (rowType === 'recent') return initRecentRow(root);
      if (rowType === 'recommendations') return initRecommendationsRow(root);

      initGallery(root);
      initQuantity(root);
      initBundle(root);
      initSticky(root);
      saveRecent(root);
    });
  }

  // Quick add "+" on product cards (also works for cards inserted later)
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mf-quick-add]');
    if (!button) return;
    button.disabled = true;
    try {
      await addToCart([{ id: Number(button.dataset.mfQuickAdd), quantity: 1 }]);
      button.classList.add('is-added');
      button.textContent = '✓';
      setTimeout(() => {
        button.classList.remove('is-added');
        button.textContent = '+';
      }, 1800);
    } catch (error) {
      button.title = error.message || 'No se pudo agregar';
    } finally {
      button.disabled = false;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
